module.exports = __webpack_public_path__ + "static/media/veneto-village-27.aba50d55.jpg";